import { BANK_PAYMENT_SLIP_ENTRY_TRANSACTION_REQUEST, GET_BANK_PAYMENT_SLIP_ENTRY_TRANSACTIONS, BANK_PAYMENT_SLIP_ENTRY_TRANSACTION_REQUEST_FAILURE } from '../types';

const initialState = {
  bankPaymentSlipEntryTransactions: [],
  loading: false,
  error: null,
};

const bankPaymentSlipEntryTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_PAYMENT_SLIP_ENTRY_TRANSACTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BANK_PAYMENT_SLIP_ENTRY_TRANSACTIONS: {
      return {
        ...state,
        bankPaymentSlipEntryTransactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case BANK_PAYMENT_SLIP_ENTRY_TRANSACTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default bankPaymentSlipEntryTransactionReducer;